module.exports = __webpack_public_path__ + "img/6.c188c91a.jpg";